export default __webpack_public_path__ + "static/running-62518cd6b493e9b9bb51d8ec1a68e4d9.svg";